<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <h2
      class="cf-title cf-title--2"
      data-test-id="title"
    >
      {{ content.ReconfirmPickupLocation.title }}
    </h2>

    <img
      class="cf-image cf-image--rounded"
      :src="locationMapImgSrc"
      style="min-height: 175px; aspect-ratio: 2; background-color: var(--color-light-gray);"
      :alt="`${location.description} Map`"
      data-test-id="map-image"
      onerror="this.src='/images/image-not-found.png';"
    >

    <div
      class="cf-flex cf-flex--column cf-flex--gap-12"
      data-test-id="location-info"
    >
      <h4 class="cf-title cf-title--2">
        {{ location.description }}
      </h4>

      <p class="cf-subtitle cf-subtitle--2">
        {{ location.address.line1.trim() }}<br>
        <template
          v-if="location.address.landmarkOrCrossStreet"
        >
          ({{ location.address.landmarkOrCrossStreet.trim() }})<br>
        </template>
        {{ location.address.city.trim() }},
        {{ location.address.state.trim() }}
        {{ location.address.postalCode.trim() }}
      </p>
    </div>

    <p
      class="cf-subtitle cf-subtitle--2"
      data-test-id="confirmation-message"
    >
      {{ content.ReconfirmPickupLocation.description }}
    </p>

    <button
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      type="button"
      data-test-id="confirm-button"
      @click="$emit('confirm')"
    >
      {{ content.ReconfirmPickupLocation.metadata.primaryCta }}
    </button>

    <button
      class="cf-button cf-button--secondary cf-button--lg cf-button--fill"
      type="button"
      data-test-id="change-location-button"
      @click="$openModal('editOrderDetails', {}, {
        closeModal: 'confirmPickupLocation'
      })"
    >
      {{ content.ReconfirmPickupLocation.metadata.secondaryCta }}
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'CfConfirmLocation',

    props: {
      location: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),

      locationMapImgSrc() {
        const primaryColorHex = this.merchant.options.skinOptions.primaryColor.split('#')[1];
        const { line1, city, state, postalCode } = this.location.address;

        const params = new URLSearchParams({
          zoom: 15,
          scale: 2,
          size: '500x250',
          format: 'jpg',
          markers: `color:0x${primaryColorHex}|${[line1, city, state, postalCode].join(' ')}`
        });

        [
          'feature:poi.attraction|visibility:off',
          'feature:poi.business|visibility:off',
          'feature:poi.medical|visibility:off',
          'feature:poi.place_of_worship|visibility:off',
          'feature:poi.school|visibility:off',
          'feature:poi.sports_complex|visibility:off',
          'feature:transit|visibility:off',
          'feature:water|geometry.fill|color:0x85BFFA'
        ].forEach(style => params.append('style', style));

        return `/google-api/static-map?${params.toString()}`;
      }
    }
  };
</script>
